/*
==========================================================
MECANICAR - PICKEASY CUSTOM
Versión 1.9
==========================================================
*/

document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(() => {
        customizePickeasy();
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    customizePickeasy();
});

function customizePickeasy() {

    document.querySelectorAll("*").forEach(el => {
        if (!el.children.length) {
            const txt = el.textContent.trim();
            switch (txt) {
                case "Store Pickup":
                    el.textContent = "Agenda en Taller";
                    break;

                case "Standard Shipping":
                    el.innerHTML = `
                        <div style="display:flex;flex-direction:column;align-items:center;line-height:1.15;">
                            <span>Envio a domicilio</span>
                            <span style="font-size:11px;font-weight:400;opacity:.85;margin-top:3px;">
                                (solo productos)
                            </span>
                        </div>
                    `;
                    break;

                case "Pickup Locations":
                    el.textContent = "Selecciona tu taller";
                    break;

                case "When would you like to get this Order?":
                    el.textContent = "Fecha y hora de atención";
                    break;
            }
        }
    });

    document.querySelectorAll("input").forEach(input => {
        const ph = input.getAttribute("placeholder");
        if (!ph) return;

        if (ph === "Select date") {
            input.setAttribute("placeholder", "Selecciona fecha");
        }

        if (ph === "Select time") {
            input.setAttribute("placeholder", "Selecciona hora");
        }

        if (ph === "Enter your zip code") {
            input.closest("div")?.remove();
        }
    });

    //==============================
    // Mensaje bajo "Fecha y hora de atención"
    //==============================

    const heading = document.getElementById("orders-slots-heading");

    if (heading && !document.getElementById("mecanicar-pickeasy-note")) {

        const note = document.createElement("div");

        note.id = "mecanicar-pickeasy-note";

        note.style.cssText = `
            font-size:12px;
            line-height:1.45;
            color:#666;
            margin:8px 0 14px;
        `;

        note.innerHTML = `
            📅 <strong>Hora referencial.</strong> Nuestro equipo hará todo lo posible por respetar el horario seleccionado; sin embargo, la atención puede variar según la carga de trabajo del taller.
        `;

        heading.insertAdjacentElement("afterend", note);
    }

    // Color removido del JS — ahora lo maneja el CSS por estado activo/inactivo
}